import { IMapper, useMapper } from '@fareye/common'
import { IPageRenderConfig } from '@fareye/types'
import { RenderControl } from '@fareye/ui'
import React from 'react'
import version from '../config/npmVersions'
import { IntransitLayout } from './IntransitLayout'
//NOTE: This config is used to render this Route Listing we will move this to server.

export function IntransitMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <RenderControl variant="m" state={apiData}>
      <IntransitLayout {...props} config={apiData.data as IPageRenderConfig} />
    </RenderControl>
  )
}
